import React from 'react';

var Time = function Time(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12 19a7 7 0 1 0 0-14 7 7 0 0 0 0 14zm0 2a9 9 0 1 1 0-18 9 9 0 0 1 0 18zm1-13a1 1 0 0 0-2 0v5.065l4.052 3.039a1 1 0 0 0 1.2-1.6L13 12.065V8z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

Time.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
import iconHandler from './hoc';
export { Time as icon };
export default iconHandler(Time);


//////////////////
// WEBPACK FOOTER
// ./~/@jsluna/icons/dist/Time.js
// module id = 628
// module chunks = 0